export const NEXT_BUTTON_WIDTH = 60;
